import { Box, Flex, Text, getPaletteColor } from 'pcln-design-system'
import styled, { css } from 'styled-components'

export const Wrapper = styled(Flex)`
  ${(props) => props.theme.mediaQueries.sm} {
    border-left: 1px solid ${getPaletteColor('border.base')};
  }
`

export const AlignedText = styled(Text)`
  text-align: right;
  ${(props) => props.theme.mediaQueries.sm} {
    text-align: center;
    font-size: 12px;
  }
  ${({ whiteSpace }) => whiteSpace && `white-space: ${whiteSpace};`}
`

export const LargerCentered = styled(Flex)`
  justify-content: flex-end;

  ${(props) => props.theme.mediaQueries.sm} {
    justify-content: center;
  }
`

export const ShowBoxLarger = styled(Box)`
  display: none;
  ${(props) => props.theme.mediaQueries.sm} {
    display: block;
  }
`

export const FareBrandName = styled(Text)`
  white-space: nowrap;
  text-transform: capitalize;
  text-overflow: ellipsis;
  overflow: hidden;
  ${(props) => props.theme.mediaQueries.sm} {
    text-transform: uppercase;
  }
`

export const MobileOnlyAffirmBox = styled(Box)`
  ${({ shouldHide }) =>
    shouldHide &&
    css`
      visibility: hidden;
    `}

  display: block;
  white-space: nowrap;
  a {
    text-align: right !important;
    font-size: 10px !important;
  }
  ${(props) => props.theme.mediaQueries.md} {
    display: none;
  }
`
